// ============================================================
// Monthly carrier rating — the carrier scorecard (carrierStats.js)
// for one calendar month, with the previous month for comparison.
// Input for operational contracts and price talks with the carrier.
// ============================================================

import { carrierHistory, aggregate } from './carrierStats';

// History dates are local midnights stored as ISO (UTC), so read the month locally.
const monthOf = (iso) => {
  const d = new Date(iso);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
};

// A month counts as complete when the history covers most of its working days.
const MIN_DAYS = 15;

// Months in the history, newest first, with their number of working days.
export function ratingMonths() {
  const counts = {};
  carrierHistory.forEach(d => { counts[monthOf(d.date)] = (counts[monthOf(d.date)] || 0) + 1; });
  return Object.entries(counts)
    .map(([month, days]) => ({ month, days, complete: days >= MIN_DAYS }))
    .sort((a, b) => b.month.localeCompare(a.month));
}

// Newest complete month: the default for a new rating.
export const defaultRatingMonth = () => (ratingMonths().find(m => m.complete) || ratingMonths()[0]).month;

// Rating of one carrier for `month` (YYYY-MM) and the month before, if the history has it.
export function carrierMonthly(carrierId, month) {
  const rows = carrierHistory.filter(d => monthOf(d.date) === month);
  const months = ratingMonths();
  const prev = months[months.findIndex(m => m.month === month) + 1];
  const prevRows = prev ? carrierHistory.filter(d => monthOf(d.date) === prev.month) : [];
  return {
    month,
    days: rows.length,
    now: aggregate(rows, carrierId),
    prevMonth: prev?.month || null,
    prev: prevRows.length ? aggregate(prevRows, carrierId) : null,
    // Share of the month already in the pilot (automatic follow-up running).
    pilotPct: rows.length ? Math.round((rows.filter(d => d.pilot).length / rows.length) * 100) : 0,
  };
}
